import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function AlbumSort() {
  const $ = _c(9);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">언제 어디서든 손쉬운 사진첩 정리</p>;
    t1 = <h4 className="title text_primary">날짜, 주소, 폴더별 정리</h4>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li>{t1}<div className="group_view"><Image className="img_guide" src="/image/desktop/popup/album03_01.png" alt={"\uB0A0\uC9DC, \uC8FC\uC18C, \uD3F4\uB354\uBCC4 \uC815\uB9AC"} width={100} height={100} /><Image className="img_guide" src="/image/desktop/popup/album03_02.png" alt={"\uB098\uB9CC\uC758 \uD3F4\uB354 \uC815\uB9AC"} width={100} height={100} /></div></li>;
    t3 = <h4 className="title text_primary">집찍고 이실장 연동</h4>;
    t4 = <p className="desc">이실장 PC에서도 날짜, 주소, 폴더별 손쉬운 사진관리</p>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image className="img_guide" src="/image/desktop/popup/album03_03.png" alt={"\uB0A0\uC9DC\uBCC4 \uC0AC\uC9C4\uAD00\uB9AC"} width={100} height={100} />;
    t6 = <Image className="img_guide" src="/image/desktop/popup/album03_04.png" alt={"\uC8FC\uC18C\uBCC4 \uC0AC\uC9C4\uAD00\uB9AC"} width={100} height={100} />;
    t7 = <Image className="img_guide" src="/image/desktop/popup/album03_05.png" alt={"\uD3F4\uB354\uBCC4 \uC0AC\uC9C4\uAD00\uB9AC"} width={100} height={100} />;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <>{t0}<ul>{t2}<li>{t3}{t4}<div className="group_view">{t5}{t6}{t7}<a className="banner" href="https://www.aipartner.com/help/faq?seq=295" target="_blank" rel="noopener"><Image src="/image/desktop/popup/album03_banner.png" alt={"\uC0AC\uC9C4 \uCC0D\uC73C\uBA74 \uC8FC\uC18C\uBCC4 \uC790\uB3D9 \uBD84\uB958! \uC61B\uB0A0 \uC0AC\uC9C4\uAE4C\uC9C0 \uD55C\uBC88\uC5D0. \uC790\uC138\uD788 \uBCF4\uAE30"} width={100} height={100} /></a></div></li></ul></>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}